import useSWR from "swr";


export const useFetchGoogleReviewReplyText = (restaurantId: string, reviewId?: string) => {
  const fetcherKey = reviewId ? `/external_api/restaurants/${restaurantId}/google/review-replies/${reviewId}/` : null;
  const { data: replyText, error, isLoading } = useSWR<string>(fetcherKey);
  return { replyText, isLoading, error };
};